import CurrencySection from './currency-section';

export default CurrencySection;